import moment from 'moment'

export const formatUTCDate = (date: any) => moment.utc(date).format('MM/DD/YYYY')

export const formatNoUTCDate = (date: any) => moment(date).format('MM/DD/YYYY')

export const formatCompleteDate = (cell: any) => moment.utc(cell).format('MM/DD/YYYY')

const numberWithCommas = (x: string) => {
  const parts = x.split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

export const formatDollar = (dollar: number) => `$${numberWithCommas(dollar.toFixed(2))}`

export const truncate = (characterLimit: number, input: string | undefined): string => {
  if (typeof input === 'string')
    return input.substring(0, characterLimit)
  else
    return ''
}

export const replaceSpecialChars = (str: string) => str.replace(/[^a-zA-Z0-9]/g, '')